<template>
  <!-- <section> -->
  <v-container fluid>
    <material-card icon="mdi-clipboard-text" inline title="User Details">
      <v-card-actions>
        <a @click="$router.back()">
          <v-btn v-if="$vuetify.breakpoint.smAndUp" elevation="1" absolute right top> <v-icon left>mdi-arrow-left</v-icon>back</v-btn>
          <v-btn v-else fixed right fab small color="grey lighten-2" elevation="1" class="mr-n2 mt-10" style="opacity:.6;"> <v-icon>mdi-arrow-left</v-icon></v-btn>
        </a>
      </v-card-actions>
      <v-card flat class="px-2">
        <v-row>
          <v-col cols="12" md="6">
            <label class="font-weight-medium body-2">First Name</label>
            <v-text-field class="my-0 py-1" v-model="userObj.firstName" disabled></v-text-field>
          </v-col>
          <v-col cols="12" md="6">
            <label class="font-weight-medium body-2">Last Name</label>
            <v-text-field class="my-0 py-1" v-model="userObj.lastName" disabled></v-text-field>
          </v-col>
          <v-col cols="12" md="6">
            <label class="font-weight-medium body-2">Email address</label>
            <v-text-field class="my-0 py-1" type="email" name="email" v-model="userObj.email" disabled></v-text-field>
          </v-col>
          <v-col cols="12" md="6">
            <label class="font-weight-medium body-2">Concept</label>
            <v-text-field class="my-0 py-1" v-model="userObj.concept" disabled></v-text-field>
          </v-col>
          <v-col cols="12" md="6">
            <label class="font-weight-medium body-2">Role</label>
            <v-text-field class="my-0 py-1" v-model="userObj.role" disabled></v-text-field>
          </v-col>
          <v-col cols="12" md="6">
            <label class="font-weight-medium body-2">Department</label>
            <v-text-field class="my-0 py-1" v-model="userObj.department" disabled></v-text-field>
          </v-col>
          <v-col cols="12" md="6">
            <label class="font-weight-medium body-2">Franchisee</label>
            <v-textarea class="my-0 py-1" v-model="userObj.franchisee" auto-grow disabled></v-textarea>
          </v-col>
        </v-row>
      </v-card>
    </material-card>
    <loading-icon :value="isLoading" />
  </v-container>
  <!-- <section class="container section page-header section is-main-section">
      <div>
        <card-component>
          <div class="columns form-row">
            <div class="column">
              <div class="field">
                <label class="font-weight-medium body-2">First Name</label>
                <div class="control">
                  <v-text-field class="my-0 py-1" v-model="userObj.firstName" disabled />
                </div>
              </div>
            </div>
            <div class="column">
              <div class="field">
                <label class="font-weight-medium body-2">Last Name</label>
                <div class="control">
                  <v-text-field   v-model="userObj.lastName" disabled ><v-text-field>
                </div>
              </div>
            </div>
          </div>
          <div class="columns form-row">
            <div class="column is-6">
              <div class="field">
                <label class="font-weight-medium body-2">Email address</label>
                <div class="control">
                  <v-text-field class="my-0 py-1" type="email" name="email" v-model="userObj.email" disabled ></v-text-field>
                </div>
              </div>
            </div>
            <div class="column is-6">
              <div class="field">
                <label class="font-weight-medium body-2">Concept</label>
                <div class="control">
                  <v-text-field   v-model="userObj.concept" disabled ></v-text-field>
                </div>
              </div>
            </div>
          </div>
          <div class="columns form-row">
            <div class="column is-6">
              <div class="field">
                <label class="font-weight-medium body-2">Role</label>

                <v-text-field class="my-0 py-1" v-model="userObj.role" disabled ></v-text-field>
              </div>
            </div>
            <div class="column is-6">
              <div class="field">
                <label class="font-weight-medium body-2">Franchisee</label>
                <div class="control">
                  <v-text-field class="my-0 py-1" v-model="userObj.franchisee" disabled ></v-text-field>
                </div>
              </div>
            </div>
          </div>
        </card-component>
      </div>
    </section> -->
  <!-- </section> -->
</template>
<script>
import MaterialCard from '@/components/template/MaterialCard'
import constants from '@/utils/constants'
const _ = require('lodash')

export default {
  name: 'ViewUser',
  props: ['adminUserID'],
  components: {
    MaterialCard
  },
  data () {
    return {
      userObj: {
        firstName: '',
        lastName: '',
        email: '',
        role: '',
        franchisee: '',
        concept: '',
        department: '',
        isLoading: false
      },
      loadingComponent: null
    }
  },
  created () {
    if (this.adminUserID) {
      this.getTitle = 'User Details'
      this.getUserDetails(this.adminUserID)
    }
  },
  methods: {
    getUserDetails: async function (adminUserID) {
      try {
        this.isLoading = true
        const response = await http.get(`${constants.API_URL}/api/admin/${adminUserID}`)
        this.isLoading = false
        const userObj1 = response.data
        let roleId1 = _.map(userObj1.userRoleMaps, 'role')
        let roleId = _.map(roleId1, 'role')
        let franchisee1 = _.map(userObj1.franchiseeUsersMaps, 'franchisee')
        let franchisee = _.map(franchisee1, 'companyName')

        this.userObj = {
          firstName: userObj1.firstName,
          lastName: userObj1.lastName,
          email: userObj1.email,
          role: roleId,
          password: '',
          franchisee: franchisee,
          concept: userObj1.concept,
          department: userObj1.department
        }

        return this.userObj
      } catch (e) {
        this.isLoading = false
        const errorMessage = (e && e.response && e.response.data.message) || e.message
        console.log('Error While fetching User', errorMessage)

        return this.$buefy.dialog.alert({
          message: errorMessage,
          type: 'is-danger',
          hasIcon: true,
          animation: 'zoom-out',
          size: 'is-medium',

          icon: ' mdi-exclamation',
          iconPack: 'mdi',
          ariaRole: 'alertdialog',
          ariaModal: true
        })
      }
    }
  }
}
</script>

<style lang="scss" scoped>
select {
  -moz-appearance: window;
  -webkit-appearance: none;
  background: #f5f5f5 url('/images/arrow_down.png') right center no-repeat;
  padding-right: 20px;
}
@-moz-document url-prefix() {
  .wrapper {
    background: #f5f5f5 url('/images/arrow_down.png') right center no-repeat;
    padding-right: 20px;
  }
}

.select {
  width: 100%;
}
</style>
